import Window from "../window/Window.jsx";

function Projects({ data }) {
  return (
    <Window id="projects" title="Mes projets">
      {data.map((project, i) => (
        <section key={project.titre + "-" + i}>
          <a href={project.url} target="blank_">
            <h3>
              <img src={project.icon} /> 
              {project.titre}
            </h3>
            <p>{project.description}</p>
            <img src={project.image} />
          </a>
        </section>
      ))}
    </Window>
  );
}

export default Projects;
